import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private readonly THEME_KEY = 'theme';
  public static readonly DEFAULT_THEME = 'golden-green';
  //public static readonly DEFAULT_THEME = 'indigo-light';

  private themeSubject: BehaviorSubject<string>;
  public theme$: Observable<string>;

  constructor() {
    const savedTheme = localStorage.getItem(this.THEME_KEY) || ThemeService.DEFAULT_THEME;
    this.themeSubject = new BehaviorSubject<string>(savedTheme);
    this.theme$ = this.themeSubject.asObservable();

    // Apply the initial theme immediately during service construction
    this.applyThemeToDocument(savedTheme);
  }

  public setTheme(theme: string): void {
    localStorage.setItem(this.THEME_KEY, theme);
    this.applyThemeToDocument(theme);
    this.themeSubject.next(theme);
  }

  public get currentTheme(): string {
    return this.themeSubject.value;
  }

  private applyThemeToDocument(theme: string): void {
    document.documentElement.setAttribute('data-theme', theme);
    // Also apply the theme as a class to the body so Material overlays inherit the skin
    document.body.classList.remove(
      'golden-green', 'indigo-light', 'teal-light', 'red-light',
      'gray-light', 'blue-dark', 'green-dark', 'pink-dark', 'gray-dark'
    );
    document.body.classList.add(theme);
  }
}
